<template>
  <div class="form-section">
    <div class="form-container">
      <!-- 手机号输入 -->
      <div class="form-item">
        <div class="input-wrapper">
          <input
            v-track ="{type:'input', event:'输入手机号'}"
            v-model="form.phone"
            type="tel"
            maxlength="11"
            :placeholder="phonePlaceholder"
            class="phone-input"
            @blur="validatePhone"
          />
          <i class="showPreferential" :style="handGifStyle"></i>
        </div>
      </div>

      <!-- 领取流程说明 -->
      <div class="flow-text" v-if="showFlowText" :style="flowTextStyle">
        <span>{{ flowText }}</span>
      </div>

      <!-- 支付方式 -->
      <div class="pay-section" v-if="showPaySection">
        <div class="pay-label">支付方式</div>
        <div class="pay-options">
          <div class="pay-option active">
            <span class="radio-icon"></span>
            <span class="pay-name">微信</span>
          </div>
        </div>
      </div>

      <!-- 提交按钮 -->
      <div class="submit-section" ref="submitSection">
        <div class="submit-btn-wrapper" @click="handleSubmit" v-track="{type:'click', event:'点击立即办理按钮'}">
          <img
            :src="submitButtonImage"
            alt="立即办理"
            class="submit-img"
          />
        </div>
      </div>

      <!-- 价格说明 -->
      <div class="price-text" v-if="showPriceText" :style="priceTextStyle">
        <span>{{ priceText }}</span>
      </div>



      <!-- 协议勾选 -->
      <div class="agreement-section" v-if="showAgreement" :style="{ textAlign: agreementStyle.textAlign }">
        <div class="agreement-wrapper" v-track="{type:'click', event:'勾选协议'}" @click="toggleAgreement" :style="{ justifyContent: agreementStyle.textAlign === 'center' ? 'center' : (agreementStyle.textAlign === 'right' ? 'flex-end' : 'flex-start') }">
          <span class="checkbox" :class="{ checked: form.agreed }">
            <i v-if="form.agreed" class="check-icon">✓</i>
          </span>
          <span class="agreement-text" :style="agreementStyle">
            我已阅读并同意
            <span class="link" v-track="{type:'click', event:'查看' + privacyTitle}" :style="agreementLinkStyle" @click.stop="showPrivacy">《{{ privacyTitle }}》</span>
            <span class="link" v-track="{type:'click', event:'查看' + serviceTitle}" :style="agreementLinkStyle" @click.stop="showSubscription">《{{ serviceTitle }}》</span>
          </span>
        </div>
      </div>

      <!-- 客服电话 -->
      <div class="customer-service" v-if="showCustomerService" :style="customerServiceStyle">
        <span class="service-label">{{ customerServiceLabel }}</span>
        <span class="service-phone" @click="callCustomerService">{{ customerServicePhone }}</span>
      </div>

    </div>

    <!-- 固定底部按钮 -->
    <div class="fixed-submit-section" v-show="isFixedVisible">
      <div class="fixed-submit-wrapper" @click="handleSubmit">
        <img
          :src="submitButtonImage"
          alt="立即办理"
          class="fixed-submit-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {trackMixin} from "@/mixins/trackMixin";

export default {
  mixins: [trackMixin],
  name: 'FormSection',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    // 价格选择器的数据
    priceData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      form: {
        phone: '',
        agreed: false
      },
      errors: {
        phone: ''
      },
      isFixedVisible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.form.phone)
    },
    // 从 config 获取配置，使用默认值
    phonePlaceholder() {
      return this.config.phonePlaceholder || '请输入领取权益的手机号码'
    },
    submitButtonImage() {
      return this.config.submitButtonImage || require('@/assets/images/submit-btn.png')
    },
    showPriceText() {
      return this.config.priceText?.show !== false
    },
    showFlowText() {
      return this.config.flowText?.show !== false
    },
    priceText() {
      return this.config.priceText.text
    },
    flowText() {
      return this.config.flowText.text
    },
    flowTextStyle() {
      return {
        color: this.config.flowText?.color || '#006AFF'
      }
    },
    showPaySection() {
      return this.config.showPaySection !== false
    },
    showAgreement() {
      return this.config.showAgreement !== false
    },
    privacyTitle() {
      return this.config.agreement?.privacyTitle || '个人信息保护政策'
    },
    serviceTitle() {
      return this.config.agreement?.serviceTitle || '自动扣费--连续订阅服务协议'
    },
    privacyUrl() {
      return this.config.agreement?.privacyUrl || '/privacy.html'
    },
    serviceUrl() {
      return this.config.agreement?.serviceUrl || '/agreement.html'
    },
    handGifUrl() {
      return this.config.handGifUrl || 'https://wechat.1haonet.com/h5/v2.7.6/img/d-hand1-showPreferential.966b5b7e.gif'
    },
    handGifStyle() {
      return {
        background: `url(${this.handGifUrl}) no-repeat`,
        backgroundSize: '70%'
      }
    },
    // 价格说明样式
    priceTextStyle() {
      return {
        color: this.config.priceText?.color || '#007BFF'
      }
    },
    // 客服电话配置
    showCustomerService() {
      return this.config.customerService.show !== false
    },
    customerServiceLabel() {
      return this.config.customerService?.label || '客服电话：'
    },
    customerServicePhone() {
      return this.config.customerService?.phone || '400-xxx-xxxx'
    },
    customerServiceStyle() {
      return {
        color: this.config.customerService?.color || '#E7401E',
        fontSize: this.config.customerService?.fontSize || '0.32rem'
      }
    },
    // 协议勾选配置
    agreementStyle() {
      return {
        color: this.config.agreement?.color || '#000',
        fontSize: this.config.agreement?.fontSize || '0.22rem',
        textAlign: this.config.agreement?.align || 'center'
      }
    },
    agreementLinkStyle() {
      return {
        // color: this.config.agreement?.linkColor || '#000',
        textDecoration: this.config.agreement?.linkUnderline !== false ? 'underline' : 'none'
      }
    }
  },

  methods: {
    handleScroll() {
      const submitSection = this.$refs.submitSection
      if (submitSection) {
        const rect = submitSection.getBoundingClientRect()
        // 当原按钮滚出视口底部时，显示固定按钮
        this.isFixedVisible = rect.bottom < 0
      }
    },
    validatePhone() {
      if (!this.form.phone) {
        this.errors.phone = '请输入手机号'
        return false
      }
      if (!this.isPhoneValid) {
        this.errors.phone = '手机号格式错误'
        return false
      }
      this.errors.phone = ''
      return true
    },
    toggleAgreement() {
      this.form.agreed = !this.form.agreed
    },
    handleSubmit() {
      if (!this.validatePhone()) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (this.showAgreement && !this.form.agreed) {
        this.$toast('请阅读并同意相关协议')
        return
      }

      // 组装提交数据
      const submitData = {
        phone: this.form.phone,
        agreed: this.form.agreed,
        // 价格选择器数据
        priceData: this.priceData
      }

      console.log('提交数据:', submitData)

      // 触发提交事件，将数据传递给父组件
      this.$emit('submit', submitData)

      // 提交逻辑
      this.$toast('正在处理...')
    },
    showPrivacy() {
      this.$dialog.alert({
        title: this.privacyTitle,
        message: `<iframe src="${this.privacyUrl}" style="width:100%;height:400px;border:none;"></iframe>`,
        confirmButtonText: '我知道了',
        allowHtml: true,
        closeOnClickOverlay: true
      }).catch(() => {
        // 点击遮罩层关闭时捕获错误，不处理
      })
    },
    showSubscription() {
      this.$dialog.alert({
        title: this.serviceTitle,
        message: `<iframe src="${this.serviceUrl}" style="width:100%;height:400px;border:none;"></iframe>`,
        confirmButtonText: '我知道了',
        allowHtml: true,
        closeOnClickOverlay: true
      }).catch(() => {
        // 点击遮罩层关闭时捕获错误，不处理
      })
    },
    callCustomerService() {
      this.$dialog.confirm({
        title: '提示',
        message: `是否拨打客服电话 ${this.customerServicePhone}？`,
        confirmButtonText: '立即拨打',
        cancelButtonText: '再考虑一下'
      }).then(() => {
        window.location.href = `tel:${this.customerServicePhone}`
      }).catch(() => {
        // 点击取消，关闭弹框
      })
    }
  }
}
</script>

<style lang="less" scoped>
.showPreferential {
    position: absolute;
    // left: 0;
    top: -.2rem;
    width: 6rem;
    height: 1rem;
    pointer-events: none;
    left: .5rem
}
.form-section {
  width: 100%;
  padding: 0 0.2rem;
}

.form-container {
  background: transparent;
}

.form-item {
  margin-bottom: 0.2rem;
}

.input-wrapper {
  position: relative;
}

.phone-input {
  width: 100%;
  height: 1rem;
  border: 0.02rem solid #E7401E;
  border-radius: 0.6rem;
  padding: 0 0.4rem;
  font-size: 0.32rem;
  font-weight: 500;
  color: #000;
  background: #fff;
  text-align: center;
  outline: none;

  &::placeholder {
    color: #909090;
    font-weight: normal;
  }
}

.error-text {
  color: #EF1515;
  font-size: 0.24rem;
  margin-top: 0.1rem;
  padding-left: 0.3rem;
}

.flow-text {
  text-align: center;
  margin: 0.01rem 0;
  // height: 0.4rem;
  line-height: 10%;
  position: relative;

  span {
    font-size: 0.28rem;
  }
}

.pay-section {
  display: none;
  align-items: center;
  padding: 0.2rem 0;

  .pay-label {
    width: 1.5rem;
    font-size: 0.28rem;
    color: #333;
  }

  .pay-options {
    flex: 1;
  }

  .pay-option {
    display: flex;
    align-items: center;
    gap: 0.1rem;

    .radio-icon {
      width: 0.36rem;
      height: 0.36rem;
      border-radius: 50%;
      border: 0.02rem solid #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.active .radio-icon {
      background: #E7401E;
      border-color: #E7401E;
    }

    .pay-name {
      font-size: 0.28rem;
      color: #333;
    }
  }
}

.submit-section {
  margin: 0.2rem 0;
  animation: breath-lamp 2s linear infinite;
}

.submit-btn-wrapper {
  cursor: pointer;

  .submit-img {
    width: 100%;
    height: auto;
    display: block;
    animation: flash-btn 2s ease-in-out infinite;
  }
}

@keyframes flash-btn {
  0%, 100% {
    transform: scale(1);
    filter: brightness(1);
  }
  25% {
    transform: scale(0.95);
    filter: brightness(1.2);
  }
  50% {
    transform: scale(1.02);
    filter: brightness(1);
  }
  75% {
    transform: scale(0.95);
    filter: brightness(1.2);
  }
}

.price-text {
  text-align: center;
  margin: 0.1rem 0;
  height: 0.4rem;
  line-height: 0.4rem;

  span {
    font-size: 0.28rem;
    vertical-align: middle;
  }
}

.customer-service {
  text-align: center;
  margin: 0.1rem 0;
  font-size: 0.28rem;

  .service-label {
    font-weight: 500;
  }

  .service-phone {
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
  }
}

.agreement-section {
  padding: 0.2rem 0;
}

.agreement-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 0.1rem;
  cursor: pointer;
}

.checkbox {
  width: 0.3rem;
  height: 0.3rem;
  border: 0.02rem solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.02rem;

  &.checked {
    background: #E7401E;
    border-color: #E7401E;
  }

  .check-icon {
    color: #fff;
    font-size: 0.2rem;
    font-style: normal;
  }
}

.agreement-text {
  line-height: 1.5;
}

@keyframes breath-lamp {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

// 固定底部按钮样式
.fixed-submit-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.2rem 0.3rem;
  background: transparent;
  z-index: 100;
}

.fixed-submit-wrapper {
  cursor: pointer;
  max-width: 100%;

  .fixed-submit-img {
    width: 100%;
    height: auto;
    display: block;
    animation: flash-btn 2s ease-in-out infinite;
  }
}
</style>
